module.exports = __webpack_public_path__ + "static/media/defaultAvatar.83acb063.png";